import React from "react";
import { Tag } from "antd";
import { CustomBtn } from "../../series/StyledComponent";
import { EditOutlined } from "@ant-design/icons";
import { ColumnsType } from "antd/es/table";
import { Image } from "antd";
import { getFileNameWithURL } from "../../videos/modals/AddVideosMetaDataForm";
import { episodeStatusColumn, refIdColumn } from "../../utils/table-columns";
import { DeletePopConfirm } from "../../custom-components";
import {
	amazonArtworkRole,
	amazonSizeCheck,
	AMAZON_SIZE_CHECK_TEXT,
	describeAmazonRole,
} from "../amazon-artwork";

const AMAZON_CHECK_COLOR = {
	preferred: "green",
	minimum: "gold",
	"too-small": "red",
	"wrong-aspect": "red",
	unknown: "default",
} as const;

const getThumbnailColumns = (
	editHelper: (record: any) => void,
	deleteThumbnails: (id: string) => void,
	isEpisodePage?: boolean
) => {
	const columnThumbnails: ColumnsType<any> = [
		!isEpisodePage ? {
			...refIdColumn,
			width: "120px",
			fixed: "left",
		} : {},
		!isEpisodePage ? episodeStatusColumn : {},
		{
			title: "Preview",
			dataIndex: "preview_url",
			key: "url-image",
			render: (value: string) => {
				return (
					<Image
						width={100}
						height={"auto"}
						onClick={e => e.stopPropagation()}
						src={value}
						fallback="FALLBACK_IMAGE"
					/>
				);
			},
		},
		{
			title: "File Name",
			dataIndex: "file_name",
			key: "file_name",
			render: (value: string, record: any) => {
				const fileName = getFileNameWithURL(record.url);
				return <span>{value?.trim() ? value : fileName}</span>;
			},
		},
		{
			title: "Width",
			dataIndex: "width",
			key: "width",
		},
		{
			title: "Height",
			dataIndex: "height",
			key: "height",
		},
		{
			title: "URL",
			dataIndex: "url",
			key: "url",
			width: "220px",
		},
		{
			title: "Artwork",
			key: "artwork",
			render: (_value: any, record: any) => {
				const kind = record.artwork_kind?.trim();
				const titled = record.artwork_titled?.trim();
				if (!kind && !titled) {
					return <span>— (unclassified)</span>;
				}
				return (
					<>
						{kind && (
							<Tag color="blue" title={kind}>
								{kind}
							</Tag>
						)}
						{titled && (
							<Tag color="purple" title={titled}>
								{titled}
							</Tag>
						)}
					</>
				);
			},
		},
		{
			// What an amazon-profile EPG publishes this image as, and whether its
			// dimensions meet Prime Video's spec for that role.
			title: "Amazon",
			key: "amazon",
			render: (_value: any, record: any) => {
				const role = amazonArtworkRole(record.artwork_kind, record.artwork_titled);
				if (!role) return <span>—</span>;
				const check = amazonSizeCheck(role, record.width, record.height);
				return (
					<Tag color={AMAZON_CHECK_COLOR[check]} title={`${describeAmazonRole(role)}: ${AMAZON_SIZE_CHECK_TEXT[check]}`}>
						{role}
					</Tag>
				);
			},
		},
		{
			title: "Tags",
			dataIndex: "thumbnail_tag_titles",
			key: "thumbnail_tag_titles",
			render: (value: string) => {
				return value?.length
					? value?.split(",")?.map(tag => (
							<Tag key={tag} color="success" title={tag}>
								{tag}
							</Tag>
					  ))
					: null;
			},
		},
		{
			title: "Distribution Platforms",
			dataIndex: "thumbnail_distribution_names",
			key: "thumbnail_distribution_names",
			width: "220px",
			render: (value: any) => {
				return value
					? value?.split(",").map((title: string) => (
							<Tag key={title} title={title}>
								{title}
							</Tag>
					  ))
					: "";
			},
		},
		{
			title: "Actions",
			dataIndex: "action",
			key: "action",
			render: (value, record: any) => {
				return (
					<>
						<CustomBtn
							icon={<EditOutlined />}
							type={"link"}
							onClick={e => {
								e.stopPropagation();
								editHelper(record);
							}}
						/>
						<DeletePopConfirm
							title="Delete Thumbnail?"
							deleteHandler={() => deleteThumbnails(record.id)}
						>
							Are you sure you want to delete this thumbnail?
						</DeletePopConfirm>
					</>
				);
			},
		},
	];

	return columnThumbnails;
};

export default getThumbnailColumns;
